module.exports = __webpack_public_path__ + "a57eeed3fa7c9a7c65cdf8b1aa4b9186.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/banner-icon002.png
// module id = 830
// module chunks = 3